<template>
  <div
    class="t-button-dropdown group relative flex group-focus-within:outline-structure-2"
    :class="{
      'group-focus-within:!outline-confirm-2': success,
    }"
    @mouseleave="opened = false"
  >
    <button
      v-if="!onlyIcon"
      class="disabled:duration-50 !relative box-border cursor-pointer rounded-l-md bg-structure-1 px-4 font-inter text-xs font-medium leading-8 text-white transition duration-300 hover:bg-structure-2 disabled:!cursor-not-allowed disabled:!border-transparent disabled:!bg-gray-600 disabled:!text-gray-200"
      :class="{
        '!bg-confirm-1 hover:!bg-confirm-2': success,
      }"
      :disabled="loading"
      @click="$emit('click')"
      @mouseover="opened = false"
    >
      <div :class="{ 'opacity-100': !loading, 'opacity-0': loading }">
        <slot />
      </div>
      <t-loading-spinner
        v-show="loading"
        class="position"
        style="position: absolute; top: calc(50% - 9px)"
      ></t-loading-spinner>
    </button>
    <button
      class="box-border grid cursor-pointer items-center justify-center rounded-r-md border-l border-solid border-structure-2 bg-structure-1 px-0.5 py-1.5 text-white transition duration-300 hover:bg-structure-2"
      :class="{
        '!border-confirm-2 !bg-confirm-1 hover:!bg-confirm-2': success,
        '!rounded-md !border-0 !bg-gray-500 !p-0.5 hover:!bg-gray-400 hover:!text-gray-50':
          onlyIcon,
      }"
      data-testid="t-dropdown-more-button"
      @mouseover="opened = true"
      @click.stop.prevent=""
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 13.125C10.6094 13.125 11.125 13.6406 11.125 14.25C11.125 14.8828 10.6094 15.375 10 15.375C9.36719 15.375 8.875 14.8828 8.875 14.25C8.875 13.6406 9.36719 13.125 10 13.125ZM10 9.375C10.6094 9.375 11.125 9.89062 11.125 10.5C11.125 11.1328 10.6094 11.625 10 11.625C9.36719 11.625 8.875 11.1328 8.875 10.5C8.875 9.89062 9.36719 9.375 10 9.375ZM10 7.875C9.36719 7.875 8.875 7.38281 8.875 6.75C8.875 6.14062 9.36719 5.625 10 5.625C10.6094 5.625 11.125 6.14062 11.125 6.75C11.125 7.38281 10.6094 7.875 10 7.875Z"
          fill="currentColor"
        />
      </svg>
    </button>

    <div
      v-show="opened"
      class="dropdown absolute right-[-12px] top-[100%] z-[10] box-border w-max min-w-[100%] max-w-[170px] p-3 pt-1"
    >
      <div
        class="box-border w-max min-w-[100%] max-w-[170px] overflow-hidden rounded-md border border-solid border-gray-500 bg-gray-600"
      >
        <slot name="dropdown" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import TLoadingSpinner from "../TLoadingSpinner/TLoadingSpinner.vue";
  import { ref } from "vue";

  defineProps({
    success: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onlyIcon: {
      type: Boolean,
      default: false,
    },
  });
  defineEmits(["click"]);

  const opened = ref(false);
</script>
<style lang="scss">
  .t-button-dropdown {
    .dropdown {
      .list-item {
        height: 32px;
        font-size: 0.75rem;
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        line-height: 1;
        // @include font(
        //   --chip-font,
        //   var(--font-medium),
        //   var(--font-2xs),
        //   1,
        //   var(--font-family-primary)
        // );
        color: var(--c-g100);
        display: flex;
        align-items: center;
        padding-left: 12px;
        padding-right: 12px;
        cursor: pointer;

        &:hover {
          background-color: var(--c-g400);
          color: var(--c-g50);
        }

        span {
          color: var(--c-g200);
          margin-left: 4px;
        }
      }
    }
  }
</style>
